export default __webpack_public_path__ + "static/card-1-c719c7dd497b1351380bd25b0d9d7bec.png";